<template>
  <div id="app" class="login ma-2">
    <v-img v-if="!isCart" src="logo_new.png" style="width: 180px" alt="moverai.com"></v-img>
    <v-card class="pa-2" v-if="isCharge">
      <VCreditCardForm v-if="isStripe"></VCreditCardForm>
      <div v-else class="d-flex justify-center mt-6">
        <v-card elevation="10" class="mt-6 ml-2  d-flex justify-center" style="width: 50%;">
          <v-container>
            <v-row
              ><v-col cols="12">
                <h1>{{ formModel.company }}</h1></v-col
              ></v-row
            >
            <v-row
              ><v-col cols="12"
                ><h3>Amount Due: {{ parseFloat(formModel.amount).toFixed(2) }}</h3></v-col
              ></v-row
            >
            <v-row
              ><v-col cols="12">{{ formModel.customer_message }}</v-col></v-row
            >
            <v-row
              ><v-col cols="12"
                ><v-text-field label=":Card Holder Name" v-model="formModel.cardholder_name"></v-text-field></v-col
            ></v-row>
            <v-row
              ><v-col><VCC :firstData="true" :formModel="formModel" :myCustomerId="myCustomerId"></VCC></v-col></v-row
          ></v-container>
        </v-card>
      </div>
    </v-card>
    <div v-else>
      <v-card class="pa-2" v-if="isCart">
        <v-available-packages :cart="cart"></v-available-packages>
      </v-card>
      <v-row v-else>
        <v-col class="ma-2 pa-4 login-panel">
          <v-card elevation="5" :flat="isCreateAccount || isCart">
            <div class="d-flex flex-column" style="height: 85vh">
              <v-spacer v-if="!isCreateAccount && !isCart" />
              <v-card :class="isCreateAccount ? 'mt-6 ml-2  d-flex justify-center' : ''" flat>
                <v-card flat v-if="!isCreateAccount && !isCart">
                  <v-card-title class="ma-6"><h2 style="font-weight: normal">Login</h2></v-card-title>
                  <v-card-text>
                    <v-form class="pa-2" flat ref="loginForm" v-model="loginForm.valid" lazy-validation>
                      <v-row>
                        <v-col cols="12" v-if="!portalId">
                          <v-text-field
                            x-large
                            outlined
                            v-model="loginForm.data.portal_id"
                            class="ma-2"
                            :rules="loginForm.nameRules"
                            name="Portal"
                            label="Portal"
                            @keyup.enter="login"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field
                            x-large
                            outlined
                            class="ma-2"
                            v-model="loginForm.data.email"
                            :rules="loginForm.emailRules"
                            label="E-mail"
                            type="email"
                            name="email"
                            @keyup.enter="login"
                            required
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field
                            x-large
                            outlined
                            v-model="loginForm.data.password"
                            class="ma-2"
                            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                            :rules="loginForm.passwordRules"
                            :type="showPassword ? 'text' : 'password'"
                            name="password"
                            label="Password"
                            @keyup.enter="login"
                            @click:append="showPassword = !showPassword"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-btn
                            text
                            x-large
                            class="ma-2"
                            block
                            :disabled="!loginForm.valid || loading"
                            color="info"
                            @click="login"
                            @keyup.enter="login"
                            :loading="loading"
                          >
                            <v-icon class="ma-2" x-large>mdi-login</v-icon>
                            Login
                          </v-btn>
                        </v-col>
                      </v-row>
                      <!-- <v-btn @click="createAccount" color="info" text
              >Create New Account</v-btn
            > -->
                    </v-form>

                    <v-alert class="ma-2" v-if="errorMessage" type="error">
                      {{ errorMessage }}
                    </v-alert>
                    <v-alert class="ma-2" v-if="successMessage" type="success">
                      {{ successMessage }}
                    </v-alert>
                  </v-card-text>
                </v-card>
                <v-card
                  class="pa-2 main-template"
                  :width="$vuetify.breakpoint.lgAndUp ? '50%' : '95%'"
                  v-else-if="!isCart"
                >
                  <v-create-account :cart="cart"></v-create-account>
                </v-card>
              </v-card></div
          ></v-card>
        </v-col>
        <v-col justify="center" align="center" v-if="$vuetify.breakpoint.mdAndUp && !isCreateAccount && !isCart">
          <v-img style="width: 45vh" src="login_banner_small.png" alt="moverai"></v-img>
          <!-- <h1 class="d-flex justify-center">When Movers Meet AI...</h1> -->
        </v-col>
      </v-row>
    </div>
    <!-- </v-dialog> -->
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import * as fun from "@/plugins/common";

export default {
  data: () => ({
    loading: false,
    isCreateAccount: false,
    isCart: false,
    dialog: true,
    showPassword: false,
    loginForm: {
      valid: true,
      data: {
        email: "",
        password: "",
        portal_id: ""
      },
      nameRules: [v => !!v || "Portal is required"],
      emailRules: [v => !!v || "Required", v => /.+@.+\..+/.test(v) || "Email must be valid"],
      passwordRules: [value => !!value || "Required.", v => (v && v.length >= 6) || "Min 6 characters"]
    },
    errorMessage: "",
    successMessage: "",
    cart: [],
    portalId: "",
    isCharge: false,
    cleared: false,
    myCustomerId: "",
    isStripe: false,
    formModel: {},
    customer: null
  }),
  components: {
    VCreateAccount: () => import("../../components/CreateAccount.vue"),
    VAvailablePackages: () => import("../../components/AvailablePackages.vue"),
    VCreditCardForm: () => import("../../components/StripeForm.vue"),
    VCC: () => import("../../components/CC.vue")
  },
  // created() {
  //   if (!this.cleared) {
  //     localStorage.clear();
  //     this.cleared = true;
  //   }
  // },
  mounted() {
    // console.log(this.$parent.$router.currentRoute.path);
    // if (this.$route.fullPath.toLowerCase().indexOf("aichat") != -1) {
    //   this.$router.go({
    //     path: this.$route.fullPath,
    //   });
    // }
    // fetch(this.serverURL)
    //   .then((r) => r.text())
    //   .then(console.log)
    //   .catch(console.error);

    this.isCharge = this.$parent.$router.currentRoute.path.includes("charge-card");
    if (this.isCharge) {
      this.myCustomerId = this.$parent.$router.currentRoute.path.split("/")[2];

      const data = {
        object_name: "my_customers",
        db_name: "admin",
        qry: {
          _id: this.myCustomerId
        }
      };
      axios.post(this.serverURL + "/get_data", data).then(response => {
        this.formModel = response.data.model[0];
      });
    }

    this.isCreateAccount = this.$parent.$router.currentRoute.path.includes("create-account");

    // console.log(this.$parent.$router.currentRoute.params.id);
    this.isCart = this.$parent.$router.currentRoute.path.includes("moverai-packages");
    localStorage.setItem("menuItems", "");
    // var newURL = "/moverai-packages";
    // this.$router.push(newURL);
    // this.$router.go({
    //   path: newURL,
    // });
    this.portalId = "";
    // eslint-disable-next-line
    var subdomain = /:\/\/([^\/]+)/.exec(window.location.href)[1].split(".")[0];
    if ((subdomain && subdomain.includes("portal")) || subdomain == "master") {
      this.portalId = subdomain.replace("portal", "");
      this.loginForm.data.portal_id = this.portalId;
    } else {
      this.portalId = this.$route.params.id;
      if (this.portalId == "undefined") {
        this.portalId = "";
      }
      // portalId = this.$route.path || this.$route.params.id ||  85;
    }
    this.loginForm.data.portal_id = this.portalId;
  },
  methods: {
    login() {
      this.errorMessage = "";
      // localStorage.removeItem("createAccount");
      var that = this;

      // this.loginForm.data.portal_id = this.portalId;
      this.loginForm.data.last_login_action_time = fun.formatDate(new Date(), false, true, true, false, true);
      // const searchParams = new URLSearchParams(window.location.search);

      // Get the value of the "name" parameter
      // portalId = searchParams.get("portalid");
      this.loading = true;

      axios
        .post(this.serverURL + "/login", this.loginForm.data, {
          withCredentials: true
        })
        .then(response => {
          console.log("Login data:", response.data);
          this.loading = false;
          if (!response.data.user) {
            that.errorMessage = response.data;
            return;
          }
          that.successMessage = "Login Successful";
          localStorage.clear();
          var store = {
            userData: response.data.user,
            portalData: response.data.portal,
            permissionsData: response.data.permissions,
            permittedActions: response.data.permitted_actions,
            loginTime: new Date(),
            idle_time: response.data.idle_time,
            portal_settings: response.data.portal_settings
          };
          localStorage.setItem(
            "loginTime",
            JSON.stringify({
              user: response.data.user,
              portalData: response.data.portal
            })
          );
          Object.keys(store).forEach(k => {
            localStorage.setItem(k, JSON.stringify(store[k]));
          });
          var url = "";
          if (
            response.data.user.roles &&
            !response.data.user.roles.includes("customer") &&
            (!that.$router.currentRoute.path.includes("/login") || that.$router.currentRoute.path != "/")
          ) {
            // this.$router.push({
            //   path: "/dashboard",
            // });
            that.$router.push("/dashboard");
            url = "/dashboard";
          } else {
            that.$router.push(that.$router.currentRoute.path);
            url = that.$router.currentRoute.path;
          }

          // try {
          //   that.$router.go({
          //     path: url,
          //   });
          // } catch (error) {
          //   //
          // }
          if (response.data.user.roles && !response.data.user.roles.includes("customer")) {
            window.location.href = "#/dashboard";
            window.location.reload();
          } else {
            window.location.href = "#/shipments";
            window.location.reload();
          }

          that.$root.$emit("loginSuccessful");
          // const userDataKey = {"userData":"user"};
          // // const userHostDataKey = "userHostData";
          // const portalDataKey = {"portalData":"portal"};
          // const permissionsDataKey = "permissionsData";
          // const permittedActions = "permittedActions";
          // commit("SET_AUTHENTICATED", true);
          // saveUserDataFromResponse(response.data, commit);

          // setUserDataLS(response.data.user, response.data.isHost);

          // setPortalDataDataLS(response.data.portal);
          // setPermissionsDataDataLS(response.data.permissions);
          // setPermittedActions(response.data.permittedActions)
          // commit("SET_ERROR", null);
        })
        .catch(reason => {
          this.loading = false;
          this.errorMessage = reason.message;
          // commit("SET_ERROR", reason.response.data);
          // dispatch("notification/SHOW_ERROR", reason.response.data, {
          //   root: true
          // });
        })
        .finally(() => {
          this.loading = false;
          // commit("SET_LOADING", false);
        });
      // this.$store.dispatch("auth/LOGIN", this.loginForm.data).then((l) => {
      //   console.log(that.$store.state.auth.isAuthenticated);
      //   if (this.$store.state.auth.isAuthenticated) {
      //     if (this.$router.currentRoute.path !== "/") {
      //       this.$router.push("/");
      //     }
      //     this.$root.$emit("loginSuccessful");
      //   }
      // });
    },
    createAccount() {
      this.isCreateAccount = true;
      // localStorage.setItem("createAccount", true);
      // this.$router.push("/create-account");
      // this.$router.currentRoute.path = "/create-account";
      // this.$router.go({
      //   path: "/create-account",
      // });
      // axios
      //   .post(this.serverURL + "/create_account", this.loginForm.data, {
      //     withCredentials: true,
      //   })
      //   .then((response) => {
      //     if (!response.data.user) {
      //       that.errorMessage = response.data;
      //       return;
      //     }
      //     that.$root.$emit("accountCreated");
      //   })
    }
  }
  // computed: {
  //   loading: function() {
  //     return this.$store.state.auth.loading;
  //   },
  // },
};
</script>
<style>
@media only screen and (min-width: 900px) {
  .charge-card {
    max-width: 400px !important;
  }
  .footer {
    position: static !important;
  }
}
</style>
